import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const StringValue = z.string();
export const StringTokenData = tokenAliasOrValue(StringValue);

export type StringValue = z.infer<typeof StringValue>;
export type StringTokenData = z.infer<typeof StringTokenData>;
